import { isNotNil } from '@tryiris-ai/js-types';
import type { Discovery, Discovery$Audio, Discovery$Control, Discovery$Video } from './types.js';

/**
 * Determines if the specified discovery is an audio device.
 *
 * @param discovery - Discovered device.
 * @returns `true` if the specified discovery is a audio device, otherwise `false`.
 */
export const isAudioDiscovery = (discovery?: Discovery): discovery is Discovery$Audio =>
  isNotNil(discovery?.audio);

/**
 * Determines if the specified discovery is a control device.
 *
 * @param discovery - Discovered device.
 * @returns `true` if the specified discovery is a control device, otherwise `false`.
 */
export const isControlDiscovery = (discovery?: Discovery): discovery is Discovery$Control =>
  isNotNil(discovery?.control);

/**
 * Determines if the specified discovery is a video device.
 *
 * @param discovery - Discovered device.
 * @returns `true` if the specified discovery is a video device, otherwise `false`.
 */
export const isVideoDiscovery = (discovery?: Discovery): discovery is Discovery$Video =>
  isNotNil(discovery?.video);
